import { gql } from '@lcs/shared/api';

export const runNdtWaitTimesGraph = gql`
   query RunWaitTimesGraph($params: ExecuteTilePostModelWaitTimesTileReportParametersInput!) {
      runWaitTimesGraphTile(params: $params) {
         data {
            averageWaitTimeLast30Minutes
            aggregateQueues
            averageWaitTimeToday
            queueDataPointSummary {
               dataPoints {
                  averageMinutesWaiting
                  timestamp
               }
               queueId
               queueName
            }
         }
         dashboardTileId
      }
   }
`;
